"use client";

import React from "react";
import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import errorIcon from "../assets/images/trading/error.svg";
import { SecuredFooter } from "./ui/secured-footer";
const TransactionFailure = ({
  title = "Transaction failed",
  message = "Something went wrong. Please try again.",
  onTryAgain,
  isLoading = false,
}) => {
  return (
    <Card className="w-full bg-white rounded-2xl !shadow-none pt-16 flex flex-col items-center text-center">
      <CardContent className="px-6 flex flex-col items-center justify-center">
        {/* Error Icon */}
        <div className="mb-16">
          <img src={errorIcon} alt="Error" className="w-[104px] h-[104px]" />
        </div>

        {/* Error Title */}
        <h2 className="text-[32px] font-semibold text-[#33125F] mb-4">
          {title}
        </h2>

        {/* Error Message */}
        <p className="text-[20px] font-normal text-[#6D6584] mb-20 max-w-md">
          {message}
        </p>

        {/* Action Button */}
        <div className="flex flex-col items-center gap-4 w-full max-w-sm">
          {onTryAgain && (
            <Button
              onClick={onTryAgain}
              disabled={isLoading}
              className="px-6 py-4 rounded-full font-semibold transition-opacity w-full h-[48px] text-sm sm:text-base bg-[linear-gradient(86.72deg,#57249C_-10.66%,#EB3366_113.47%)] text-white hover:opacity-90"
            >
              {isLoading ? "Processing..." : "Try Again"}
            </Button>
          )}
        </div>
      </CardContent>

      {/* Secured Footer */}
      <div className="w-full mt-6">
        <SecuredFooter />
      </div>
    </Card>
  );
};

export default TransactionFailure;
